import { graphql } from '../graphql/generated';

export const REQUEST_COPY_QUERY = graphql(`
  query RequestCopy($requestId: ID!, $currentPatientData: PatientDataInput) {
    requestCopy(requestId: $requestId, currentPatientData: $currentPatientData) {
      ...RequestCopyData
    }
  }
`);

export const RequestCopyFragment = graphql(`
  fragment RequestCopyData on RequestCopy {
    labInfo
    diagnose
    comment
    acute
    sampledAt
    additionalData
    elgaOptOut
    patientData {
      birthday
      city
      country
      email
      externalId
      firstName
      lastName
      gender
      zip
      svnr
      title
      street
      phone
      insuranceCode
      idCardAuthority
      idCardNumber
      idCardType
      insuranceCategory
      insuredPerson {
        phone
        street
        title
        svnr
        zip
        birthday
        gender
        firstName
        email
        country
        city
        lastName
      }
    }
    selectedParameters {
      requestableParameter {
        id
        mainParameterId
        shortName
        longName
        withoutParameterIds
        withoutParameterNames
        withParameterNames
        pricePatient
        billingInfos {
          billingType
          price
          text
          additionalText
          specialRateId
          diagnoseId
        }
        specimens {
          id
          classification
          name
          storagePeriod
          requiresLocalizations
          predefinedLocalizations
          localizationFields {
            label
            inputType
            unit
            mandatory
          }
          localizationInputEnabled
          testTubes {
            id
            color
            name
            hasImage
            labelText
            labelText2
            link
            volume
            specialPrinterRequired
          }
        }
        lab {
          id
          name
          shortName
          identifier
          aiEnabled
        }
        link
        description
        billingDescription
        importantDescription
        evalHours
        synonyms
        acute
        volume
      }
      billingInfo {
        additionalText
        billingType
        diagnoseId
        text
        price
        specialRateId
      }
    }
    unknownBillingParameters {
      id
      shortName
      longName
    }
    unavailableParameters
    orderForms {
      id
      restore
      fields {
        id
        values
        type
        formFieldId
      }
    }
    localizations {
      paramId
      specimenId
      location
      freeText
      fieldValues {
        label
        unit
        value
      }
    }
  }
`);
